// Legacy /audioMultimedia/:page slugs and the /pages/amm/:name record each
// one opens. Kept out of the redirect component so the route loader can use it
// without waiting for the component's chunk.
const AMM_PATH_MAP = {
  overview: "overview",
  faq: "faq",
  resources: "resources",
};

const DEFAULT_PAGE = "overview";

export const ammPageName = (page) => AMM_PATH_MAP[page] || DEFAULT_PAGE;
